import { ArchiveBoxIcon, ClipboardIcon, PencilSquareIcon } from "@heroicons/react/20/solid";
import { format, parse } from "date-fns";
import React from "react";
import { connect } from "react-redux";
import Tooltip from "@/tooltip";
import { Actions } from "../../../store/actions/employeeActions";
import ProgressBar from "../../common/ProgressBar";
import { roundTo2 } from "../../common/validation/Validators";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const AttachmentOfEarningsRow = ({
    attachment,
    isLast,
    openAttachmentsModal,
    openPaymentHistoryModal,
    currency,
    disabled,
    isAdmin,
    payments
}) => {
    const { id, reference, type, payment, dateOfIssue, totalAmount } = { ...attachment }
    const deductionTotal = parseFloat(payment.total) || 0
    const noPayments = payments?.length <= 0
    return (
        <div
            key={`attachmentOfEarnings${id}`}
            style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(6, minmax(0, 1fr))", padding: '1rem', borderBottom: isLast ? undefined : 'solid rgb(244,244,244) 4px' }}>
            <div style={{ gridColumn: "span 1 / span 6", textAlign: 'center', paddingLeft: '1rem' }}>
                <h5>{reference}</h5>
                <p style={{ marginBottom: 0 }}>{dateOfIssue ? format(parse(dateOfIssue, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : null}</p>
            </div>
            <div style={{ gridColumn: "span 1 / span 6", textAlign: 'center', paddingTop: '1.5rem' }}>
                <h5>{type}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 6", textAlign: 'center', paddingTop: '1.5rem' }}>
                <h5>{currency}{roundTo2(deductionTotal)}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 6", textAlign: 'center' }}>
                <ProgressBar percentage={(deductionTotal / totalAmount) * 100} style={{ height: '1.5rem' }} color={'#ea611c'} />
                <h5>{currency}{roundTo2(totalAmount - deductionTotal)}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 6", textAlign: 'center', paddingTop: '1.5rem' }}>
                <h5>{currency}{roundTo2(totalAmount)}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 6", textAlign: 'center', paddingTop: '1rem' }}>
                {isAdmin &&
                    <div
                        className="btn btn-xs btn-default"
                        type="button"
                        onClick={() => copyToClipboard(id)}
                        style={{ marginRight: 5 }} >
                        <ClipboardIcon className="h-5 w-5 text-dark-gray" style={{ marginTop: "3px" }} />
                    </div>
                }
                <div
                    onClick={() => { if (!noPayments) openPaymentHistoryModal(id, payments) }}
                    disabled={noPayments}
                    className='btn btn-xs btn-default' style={{ marginRight: 5 }}>
                    <Tooltip content={noPayments ? 'No Payments Have Been Made Yet' : 'Payment History'}>
                        <ArchiveBoxIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                    </Tooltip>
                </div>
                <div
                    onClick={() => openAttachmentsModal(attachment)}
                    className='btn btn-xs btn-default'>
                    <Tooltip content={'Edit Attachment of Earnings'}>
                        <PencilSquareIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        currency: state.company?.settings?.currency,
        payments: ownProps?.attachment?.payment?.payments,
        isAdmin: state?.my?.profile?.isAdmin,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    openAttachmentsModal: (attachment) => dispatch(Actions.toggleAttachmentEarningsModal({ open: true, attachment })),
    openPaymentHistoryModal: (attachmentId, payments) => dispatch(Actions.togglePaymentHistoryModal({ open: attachmentId, payments })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentOfEarningsRow);
